import React, { useState, useContext, useEffect } from 'react';
import { View, Text, Pressable } from 'react-native';
import styled from 'styled-components/native';
import NewPurchaseOrder from '../new';
import SubNav from '../../../elements/SubNav';
import DataTable from '@preflighttech/preflight-tables';
import Modal from '../../../elements/Modal';
import Filter from 'app/src/elements/Filter';
import { ResetSettings } from 'app/src/elements/Pagination/ResetSettings';
import { EXPENSES_WITH_COUNT, HIDE_EXPENSE } from '../queries';
import {
  MainContainer,
  ContentContainer,
  TableContainer,
  PageTitle,
  LinkContainer,
  SubNavContainer,
  TableNavbarContainer
} from '../../../elements';
import EditExpense from '../edit';
import AuthContext from '../../../contexts/AuthContext';
import { Link } from 'app/src/utils/routing';
import currencyFormatter from '../../../utils/currencyFormatter';

const PurchaseOrders = (props) => {
  const { user } = useContext(AuthContext);
  const [refetch, setRefetch] = useState();
  const [clickedExpense, setClickedExpense] = useState(undefined);
  const [showAddExpenseModal, setShowAddExpenseModal] = useState(false);
  const [showEditExpenseModal, setShowEditExpenseModal] = useState(false);
  const [filterOptions, setFilterOptions] = useState();
  const [filters, setFilters] = useState({});
  const [settings, setSettings] = useState({});
  const queryVariables = {
    filterColumns: [],
    filterNames: [],
    scopes: ['purchase_orders'],
  };

  const setFilter = (key, value) => {
    const currentFilters = {...filters};
    currentFilters[key] = value;
    setFilters(currentFilters);
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      queryVariables.filterColumns.push(key);
      queryVariables.filterNames.push(value);
    }
  });
  const columns = [
    // {
    //   key: 'assetId',
    //   label: 'Asset',
    //   hidden: assetId,
    //   content: (entry) => {
    //     return entry.entry.asset?.name
    //   }
    // },
    {
      key: 'vendorId',
      label: 'Vendor',
      content: (entry) => {
        return entry.entry.vendor?.name
      }
    },
    {
      key: 'total',
      label: 'Amount',
      content: (entry) => {
        return currencyFormatter(entry.entry.total)
      }
    },
    {
      key: 'invoiceNumber',
      label: 'Invoice Number',
      content: (entry) => {
        return entry.entry.invoiceNumber
      }
    },
    {
      key: 'paymentMethod',
      label: 'Payment Method',
      content: (entry) => {
        return entry.entry.paymentMethod
      }
    },
    {
      key: 'paymentReference',
      label: 'Payment Reference',
      content: (entry) => {
        return entry.entry.paymentReference
      }
    },
    {
      key: 'clearedOn',
      label: 'Cleared Date',
      content: (entry) => {
        return entry.entry.clearedOn ?
          moment(entry.entry.clearedOn).format('M-DD-YY') :
          '';
      }
    },
    {
      key: 'description',
      label: 'description',
      content: (entry) => {
        return entry.entry.description
      }
    },
    {
      key: 'requestedById',
      label: 'Requested By',
      content: (entry) => {
        return `${entry.entry.requestedBy?.firstName} ${entry.entry.requestedBy?.lastName}`
      }
    },
    {
      key: 'functions',
      label: 'Functions',
      content: (entry) => {
        if (user.accounting) {
          return (
            <LinkContainer>
              {/* <Pressable
                onPress={() => {
                  setClickedExpense(entry.entry);
                  setShowEditExpenseModal(true)
                }}
                style={{marginLeft: '10px'}}
                key={`sale-expense-link-${entry.entry.id}`}
                name={`sale-expense-link-${entry.entry.id}`}
              > */}
              <Link to={`/purchase-orders/${entry.entry.id}`}>
                <Text>
                  Edit
                </Text>
              </Link>
              {/* </Pressable> */}
            </LinkContainer>
          )
        }
      }
    }
  ]

  const buttons = (
    <View style={{display: 'flex', flexDirection: 'row'}}>
      <Filter
        clearFilters={() => {
          setFilters({})
          setShowModal(false)
        }}
        filters={filters}
        setFilters={setFilters}
      >
        {/* <View style={{padding: '20px', justifyContent: 'space-between'}}>
          <Text>Sale Name:</Text>
          <input
            type={'text'}
            name="name"
            onChange={e => setFilter('name', e.target.value)}
            value={filters.name || ''}
            style={inputStyle}
          />
          <Text>Start:</Text>
          <input
            type={'text'}
            name="startAt"
            onChange={e => setFilter('startAt', e.target.value)}
            value={filters.startAt || ''}
            style={inputStyle}
          />
          <Text>End:</Text>
          <input
            type={'text'}
            name="endAt"
            onChange={e => setFilter('endAt', e.target.value)}
            value={filters.endAt || ''}
            style={inputStyle}
          />
          <Text>Pre Bid Open At:</Text>
          <input
            type={'text'}
            name="preBidOpenAt"
            onChange={e => setFilter('preBidOpenAt', e.target.value)}
            value={filters.preBidOpenAt || ''}
            style={inputStyle}
          />
          <Text>Status:</Text>
          <select
            type={'select'}
            name="status"
            onChange={e => setFilter('status', e.target.value)}
            value={filters.status || ''}
          >
            <option key={`status-all`}>
              {'All'}
            </option>
            {STATUSES.map(status =>
              <option key={`status-${status}`}>
                {status}
              </option>
            )}
          </select>
        </View> */}
      </Filter>
      <ResetSettings />
    </View>
  );

  return (
    <MainContainer>
      <SubNavContainer>
        <SubNav>
          {getSubNavContents()}
        </SubNav>
      </SubNavContainer>
      <ContentContainer>
      <PageTitle>Purchase Orders</PageTitle>
        <br /><br />
        <TableContainer>
          <DataTable.Gql
            setRefetch={setRefetch}
            query={EXPENSES_WITH_COUNT}
            queryName='expensesWithCount'
            columns={columns}
            buttons={buttons}
            lengthMenu={ [10, 25, 50, 'All'] }
            setSettings={setSettings}
            dataUpdated={data => setFilterOptions(data?.expensesWithCount)}
            htmlTable
            queryVariables={queryVariables}
          />
        </TableContainer>
      </ContentContainer>
      {showEditExpenseModal &&
        <Modal
          refetch={refetch}
          showModal={showEditExpenseModal}
          setShowModal={setShowEditExpenseModal}
          modalType={'Edit Expense'}
          objectName={clickedExpense.name}
        >
          <EditExpense
            setShowModal={setShowEditExpenseModal}
            refetch={refetch}
            expense={clickedExpense}
          />
        </Modal>
      }
    </MainContainer>
  )

  function getSubNavContents() {
    return (
      <View>
        {getLinks()}
      </View>
    )
    function getLinks() {
      return (
        <View>
          <Pressable
            onPress={() => setShowAddExpenseModal(true)}
          >
            <Text>+ Add Purchase Order</Text>
          </Pressable>
          {showAddExpenseModal &&
            <Modal
              showModal={showAddExpenseModal}
              setShowModal={setShowAddExpenseModal}
              modalType={'Add Purchase Order'}
            >
              <NewPurchaseOrder
                setShowModal={setShowAddExpenseModal}
                refetch={refetch}
                expense={clickedExpense}
                setClickedExpense={setClickedExpense}
                setShowAddExpenseModal={setShowAddExpenseModal}
                setShowEditExpenseModal={setShowEditExpenseModal}
                newPurchaseOrder={true}
              />
            </Modal>
          }
        </View>
      )
    }
  }
}

export default PurchaseOrders;
